import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workflow_update",
  "use": "icon-workflow_update-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-workflow_update\">\n  <g stroke-width=\"2\" stroke-linecap=\"round\">\n    <path stroke=\"currentColor\" fill=\"transparent\" d=\"M12.186 27H6.444C5.094 27 4 26.023 4 24.818V10.333 5.182C4 3.977 5.094 3 6.444 3H23.556C24.906 3 26 3.977 26 5.182v5.842M26.037 17.561A6 6 0 1028 22M26.633 17.957l-.938-3.121M26.633 17.957l-2.842.675\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol